import { useUserAuthState } from '@cosuno/authentication-frontend';
import type React from 'react';

interface Props {
  authenticatedElement: React.ReactNode;
  unauthenticatedElement: React.ReactNode;
}

const AuthAwareSwitch: React.FC<Props> = ({ authenticatedElement, unauthenticatedElement }) => {
  const { isUserAuthenticated } = useUserAuthState();

  return isUserAuthenticated ? authenticatedElement : unauthenticatedElement;
};

export default AuthAwareSwitch;
